import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home            from './pages/Home';
import Product         from './pages/Product';
import PrivacyPolicy   from './pages/PrivacyPolicy';
import TermsOfService  from './pages/TermsOfService';
import Contact         from './pages/Contact';
import Waitlist from './pages/Waitlist'
import NotFound        from './pages/NotFound';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
